import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Header, InputText, Modal, Text } from "@pentabd/ui";

import {
  MODAL,
  PromotionFormDataType,
} from "@validations/HRM/promotion/promotionFormValidation";

interface PromotionCandidatesModalType {
  isModalOpen: boolean;
  onSaveAction: () => void;
  closeModal: () => void;
  isLoading: boolean;
}

export const PromotionCandidatesModal = ({
  isModalOpen,
  closeModal,
  isLoading,
}: PromotionCandidatesModalType) => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext<PromotionFormDataType>();

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
    >
      <Header
        size="sm"
        headerText={{
          header: t("PROMOTION_CANDIDATES.MODAL.LABEL"),
          subHeader: t("PROMOTION_CANDIDATES.MODAL.SUBTITLE"),
        }}
        className="px-9"
      />
      <div className="px-10 pt-9 d-flex flex-column gap-6">
        <Text color="dark" weight="semibold">
          {t("PROMOTION_CANDIDATES.MODAL.GROUP_NAME.LABEL")}
        </Text>
        <InputText
          {...register(MODAL.NAME)}
          placeholder={t("PROMOTION_CANDIDATES.MODAL.GROUP_NAME.PLACEHOLDER")}
          error={errors as any}
        />
      </div>
      <div className="p-9 d-flex justify-content-end align-items-center gap-6">
        <Button
          size="sm"
          fill="outline"
          type="light"
          onClick={closeModal}
          loading={isLoading}
        >
          {t("PROMOTION_CANDIDATES.MODAL.BUTTON.CANCEL")}
        </Button>
        <Button
          size="sm"
          htmlType="submit"
          fill="fill"
          type="primary"
          loading={isLoading}
        >
          {t("PROMOTION_CANDIDATES.MODAL.BUTTON.SAVE")}
        </Button>
      </div>
    </Modal>
  );
};
